
import api from "~api";
import setting from '../../server/settings'
import wx from 'weixin-js-sdk'

var sha1 = require('sha1');
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Panel from 'vux/src/components/panel/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

export default {
name: "scanCodes",
components: {
XHeader,Group,Cell,XTextarea,XButton,Panel,Flexbox, FlexboxItem
},
data(){
return{
title: "扫码入住",
list:[],
}
},
computed:{

},
mounted() {
this.getData()
},
methods:{
getData(){
var _this = this;
api.post('/api/stuEnter/selectStuEnterInfos').then(function (response) {
if (response.status == 200){
if(response.data.code===0){
_this.list= response.data.data.slice(0,9)
}else {
_this.$msgbox('温馨提示：',"暂无数据");
}
}else {
_this.$msgbox('温馨提示：',"服务器异常请稍后再试");
}
})
},
sortParam(obj){
var paramArr = [];
for(var o in obj){
paramArr.push(o +"="+ obj[o] +"&");
}
paramArr.sort();
var str = paramArr.join(":::").replace(/:::/g, "");
return str
},
add(){
console.log(location.href)
var time = ((new Date()).valueOf().toString()).slice(0,10);
time = Number(time)
let u = navigator.userAgent;
let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) 

var arr = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
var idvalue ='';
const n = 16;
for(var i=0;i<n;i++){
idvalue+=arr[Math.floor(Math.random()*26)];
}
var _this = this
api.post('/api/wx/getTicket').then(function (response) {
let urlx = "";
if(isIOS){
urlx=location.href;
}else{
urlx=(location.href).split('#')[0]
}


if(response.status == 200){
var params = {
"timestamp": time,
"jsapi_ticket": response.data.data + '',
"noncestr":idvalue + '',
"url":(window.location.href).split('#')[0]

};
var sign = (_this.sortParam(params)).slice(0,_this.sortParam(params).length-1)
const a = sha1(sign);

wx.config({
debug: false, // 开启调试模式,
appId: setting.appid, // 必填，企业号的唯一标识，此处填写企业号corpid
timestamp: time, // 必填，生成签名的时间戳
nonceStr: idvalue + '', // 必填，生成签名的随机串
signature: a + '',// 必填，签名，见附录1
jsApiList: ['scanQRCode','checkJsApi'] 
});
wx.ready(function(){
wx.checkJsApi({  //判断当前客户端版本是否支持指定JS接口
jsApiList: [
'scanQRCode'
],
success: function (res) {// 以键值对的形式返回，可用true，不可用false。如：{"checkResult":{"scanQRCode":true},"errMsg":"checkJsApi:ok"}
if(res.checkResult.scanQRCode != true){
alert('抱歉，当前客户端版本不支持扫一扫');
}else {
wx.scanQRCode({
needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
scanType: ["qrCode",'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
success: function (res) {
_this.$router.push({name: 'dormitoryInformation', params: {stuCode: res.resultStr}})
},
error: function(res){
console.log(res)



alert('版本过低请升级')

}
})
}
},
fail: function (res) { //检测getNetworkType该功能失败时处理
alert('checkJsApi error');

}
});

});
wx.error(function(res){
alert(JSON.stringify(res))
});






















































































































}else{

}
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/scanCodes.vue